import Modal from 'components/Modals/Modal'

function LocationClosedModal(props) {

    const { getValue, popModal } = props

    return(
        <Modal className="selected-table-modal" onClickLayout={popModal}>
            <div>
            <h1>{getValue("app_v2_locationClosed")}</h1>
            <p>{getValue("app_v2_locationClosedMessage")}</p>
            <div className="mt-3">
                <div className="btn secondary" onClick={popModal}>{getValue("app_v2_order_locationClosedBtn")}</div>
            </div>
            </div>
        </Modal>
    )
}
export default LocationClosedModal